import mapCartItem from "../services/map-cart-item";
import mapProductItem from "../services/map-product-item";

function getCurrentItem(items, find) {
    const index = items.findIndex(i => (i.variant_id === find.variant_id && i.id === find.id) && i.uid === find.uid && i.price === find.price)
    let item = null
    if(items[index]) {
        item = Object.assign({}, items[index])
    }
    return [index, item]
}

export default {
    //TODO: APP
    LOADING (state, payload = true) {
        state.app.loading = payload
    },
    ADD_NOTIFICATION (state, payload) {
        state.app.notifications.items = state.app.notifications.items.concat(payload.items)
        state.app.notifications.target = payload.target
    },
    EMPTY_NOTIFICATIONS (state) {
        state.app.notifications.items = []
    },
    INSERT_AUTH (state, payload) {
        if(payload && payload.id) {
            state.app.auth = payload
        }
    },
    INSERT_INITIAL_DATA (state, payload) {

        if(payload) {
            let keys = Object.keys(payload)
            for(let i = 0; i < keys.length; i++) {
                if(keys[i].split('.')[1]) {
                    if(state[keys[i].split('.')[0]] !== undefined && state[keys[i].split('.')[0]][keys[i].split('.')[1]] !== undefined) {
                        state[keys[i].split('.')[0]][keys[i].split('.')[1]] = payload[keys[i]]
                    }
                } else {
                    if(state[keys[i]] !== undefined) {
                        state[keys[i]] = payload[keys[i]]
                    }
                }
            }
        }

    },
    //TODO: CART
    ADD_TO_CART (state, payload) {
        if (isNaN(payload.price)) {
            payload.price = payload.regular_price;
        }

        const [index, item] = getCurrentItem(state.cart.items, payload)

        if (!state.app.products.find(product => product.id === payload.id )) {
            state.app.products.push(payload)
        }
        const areThereFreeProduct = !!(Object.keys(state.cart.items.filter(i => i.grouped_product)).length)

        if(state.cart.items[index]) {
            let quantity = Number(state.cart.items[index].quantity) + Number(payload.quantity);
            if(quantity && quantity > 9999) {
                quantity = 9999;
            }
            state.cart.items[index].quantity = quantity;
        } else {
            state.cart.items.push(JSON.parse(JSON.stringify(payload)))
        }

        if(payload.grouped_product && !areThereFreeProduct) {
            const groupedCartItem = mapCartItem({product: payload.grouped_product})
            groupedCartItem.quantity = 1
            groupedCartItem.price = 0
            const [index, item] = getCurrentItem(state.cart.items, groupedCartItem)
            if(!state.cart.items[index]) {
                state.cart.items.push(groupedCartItem)
            }
        }

        for(let j = 0; j < state.cart.items.length; j++) {

            // if(state.cart.items[j].grouped_product)
            // {
            //     state.cart.items.push(state.cart.items[j]);
            //     state.cart.items.splice(j, 1);
            // }

            if(state.cart.items[j].is_group_of  && ( !state.cart.items[j].price || state.cart.items[j].price == '0.00'))
            {
                state.cart.items.push(state.cart.items[j]);
                state.cart.items.splice(j, 1);
            }
        }

        if(!state.app.auth)
        {
            state.cart.cart_type = state.cart.cart_type == '1' ? '0' : state.cart.cart_type;
        }
    },

    SET_CART_PRODUCT_DATA (state, payload) {
        if(payload && payload.length) {
            state.app.products = []
            for(let i = 0; i < payload.length; i++) {
                state.app.products.push(mapProductItem(payload[i]))
            }
        }
    },
    SET_CART_LINKED_PRODUCT_DATA (state, payload) {
        if(payload && payload.length) {
            state.app.cartLinkedProducts = []
            for(let i = 0; i < payload.length; i++) {
                state.app.cartLinkedProducts.push(mapProductItem(payload[i]))
            }
        }
        else
        {
            state.app.cartLinkedProducts = [];
        }
    },
    SET_DATALAYER_IMPRESSIONS(state) {
        let impressions = [];
        if(state.app.cartLinkedProducts.length) {
            let productsLinked = state.app.cartLinkedProducts;
             impressions = productsLinked.map((product, i) => {
                return {
                brand: "",
                category: product.categories[0].meta_title,
                id: product.id,
                list: "Cross-Sell Products",
                name: product.title,
                position: i+1,
                price: parseFloat(product.price),
                stocklevel: ""
                };
            });

            state.data_layer_default.ecommerce.currencyCode = "USD";
            state.data_layer_default.ecommerce.impressions = impressions;
        }
        else
        {
            state.data_layer_default.ecommerce.currencyCode = "";
            state.data_layer_default.ecommerce.impressions = [];
        }


    },
    SET_DATALAYER_CART(state) {
        let items = [];
        let ecommerceItems = [];

        if(state.cart.items.length) {
            let cartItems = state.cart.items;
             items = cartItems.map((item, i) => {
                var category = "";
                var variations = "";

                if(typeof(item.categories) != "undefined" && item.categories !== null)
                    category = item.categories.length > 0 ? item.categories[0].meta_title : "";
                
                if(typeof(item.options) != "undefined" && item.options !== null)
                    variations = item.options ? Object.values(item.options).join(', ') : "";

                return {
                category: category,
                id: item.sku,
                name: item.title,
                price: parseFloat(item.price),
                quantity: item.quantity,
                sku: item.sku,
                stocklevel: "",
                variant: variations
                };
            });
            
            ecommerceItems = cartItems.map((ecommerceItem, i) => {
                var category = "";
                var variations = "";

                if(typeof(ecommerceItem.categories) != "undefined" && ecommerceItem.categories !== null)
                    category = ecommerceItem.categories.length > 0 ? ecommerceItem.categories[0].meta_title : "";

                if(typeof(ecommerceItem.options) != "undefined" && ecommerceItem.options !== null)
                    variations = ecommerceItem.options ? Object.values(ecommerceItem.options).join(', ') : "";
                
                return {
                google_business_vertical: "retail",
                id: ecommerceItem.sku,
                item_brand: "",
                item_category: category,
                item_id: ecommerceItem.sku,
                item_name: ecommerceItem.title,
                item_variant: variations,
                price: parseFloat(ecommerceItem.price),
                quantity: ecommerceItem.quantity
                };
            });

            state.data_layer_default.ecommerce.cart = items;
            state.data_layer_view_cart.ecommerce.items = ecommerceItems;
        }
        else
        {
            state.data_layer_default.ecommerce.cart = [];
            state.data_layer_default.ecommerce.items = [];
        }


    },
    SET_DATALAYER_CHECKOUT(state) {
        let items = [];
        let ecommerceItems = [];

        if(state.cart.items.length) {
            let cartItems = state.cart.items;
             items = cartItems.map((item, i) => {

                var category = "";

                if(typeof(item.categories) != "undefined" && item.categories !== null)
                    var category = item.categories.length > 0 ? item.categories[0].meta_title : "";

                return {
                category: category,
                id: item.sku,
                name: item.title,
                price: parseFloat(item.price),
                quantity: item.quantity,
                sku: item.sku,
                stocklevel: ""
                };
            });

            ecommerceItems = cartItems.map((ecommerceItem, i) => {

                var category = "";

                if(typeof(ecommerceItem.categories) != "undefined" && ecommerceItem.categories !== null)
                    var category = ecommerceItem.categories.length > 0 ? ecommerceItem.categories[0].meta_title : "";

                return {
                google_business_vertical: "retail",
                id: ecommerceItem.sku,
                item_brand: "",
                item_category: category,
                item_id: ecommerceItem.sku,
                item_name: ecommerceItem.title,
                price: parseFloat(ecommerceItem.price),
                quantity: ecommerceItem.quantity
                };
            });

            state.data_layer_checkout_default.ecommerce.checkout.products = items;
            state.data_layer_begin_checkout.ecommerce.items = ecommerceItems;
        }
        else
        {
            state.data_layer_checkout_default.ecommerce.checkout.products = [];
            state.data_layer_begin_checkout.ecommerce.items = [];
        }


    },
    SET_PRODUCT_LINKED_PRODUCT_DATA (state, payload) {
        if(payload && payload.length) {
            state.app.productLinkedProducts = []
            for(let i = 0; i < payload.length; i++) {
                state.app.productLinkedProducts.push(mapProductItem(payload[i]))
            }
        }
    },
    SAVE_COUPON (state, payload) {
        state.cart.coupon = payload
        //test commit
    },
    UPDATE_CART_QUANTITY (state, payload) {

        const [index, item] = getCurrentItem(state.cart.items, payload)
        if(state.cart.items[index] && !payload.is_group_of) {
            delete payload.product
            state.cart.items.splice(index, 1, payload)
        }

        if(!state.app.auth)
        {
            state.cart.cart_type = state.cart.cart_type == '1' ? '0' : state.cart.cart_type;
        }
    },
    UPDATE_CUSTOM_PRICE (state, payload) {

        const [index, item] = getCurrentItem(state.cart.items, payload)
        if(state.cart.items[index] && !payload.is_group_of) {
            delete payload.product
            if(payload.customPrice >= 0) {
                payload.price = payload.customPrice
            }

            state.cart.items.splice(index, 1, payload)
        }
    },
    UPDATE_CART_ITEM (state, payload) {

        if(payload.old.variant_id != payload.new.variant_id || payload.old.uid != payload.new.uid)
        {
            const variantIndex =  state.cart.items.findIndex((item, index) => item.variant_id == payload.new.variant_id && item.uid == payload.new.uid && index !== payload.cartIndex);
            const variant = state.cart.items.find((item, index) => item.variant_id == payload.new.variant_id && item.uid == payload.new.uid && index !== payload.cartIndex);
            if(variant)
            {
                payload.new.quantity = parseInt(payload.new.quantity) + parseInt(variant.quantity);
                state.cart.items.splice(variantIndex, 1)
            }
           
        }

        const [index, item] = getCurrentItem(state.cart.items, payload.old)
        if(state.cart.items[index] && !payload.is_group_of) {
            delete payload.product
            state.cart.items.splice(index, 1, payload.new)
        }

        if(!state.app.auth)
        {
            state.cart.cart_type = state.cart.cart_type == '1' ? '0' : state.cart.cart_type;
        }

    },
    LOAD_CART (state, payload) {
        if(payload) {

        }
    },
    STORE_CART_HASH (state, payload) {
        state.cart.hash = payload
    },
    REMOVE_FROM_CART (state, payload) {
        const [index, item] = getCurrentItem(state.cart.items, payload)

        if(payload.grouped_product) {
            if(payload.grouped_product) {
                let groupedCartItemIndex = state.cart.items.findIndex(i => i.id === payload.grouped_product.id)
                if (groupedCartItemIndex !== -1) {
                    state.cart.items.splice(groupedCartItemIndex, 1)
                }
            }
        }

        delete payload.product
        state.app.removedItems.push(payload)

        if(index !== -1) {
            state.cart.items.splice(index, 1)
        }

        if (state.cart.items.length) {
            const productWithGrouped = state.cart.items.filter(i => i.grouped_product)

            let groupedCartItem = null
            if (productWithGrouped.length) {
                for (let i = 0; i < productWithGrouped.length; i++) {
                    groupedCartItem = state.cart.items.find(j => j.id === productWithGrouped[i].grouped_product.id)

                    if (groupedCartItem && groupedCartItem.price === 0 && groupedCartItem.quantity === 1) {
                        break
                    }
                }
                if (!groupedCartItem && (productWithGrouped[0].grouped_product.id !== payload.id)) {
                    productWithGrouped[0].grouped_product.quantity = 1;
                    productWithGrouped[0].grouped_product.price = 0;
                    state.cart.items.push(mapCartItem({product: productWithGrouped[0].grouped_product}));
                }
            }
        }

        if(!state.app.auth)
        {
            state.cart.cart_type = state.cart.cart_type == '1' ? '0' : state.cart.cart_type;
        }
    },
    UNDO_TO_CART (state, payload) {
        const [index, item] = getCurrentItem(state.app.removedItems, payload);
        const removedNoteIndex =
            state.app.notifications.items.findIndex(
                note =>
                    (note.type === 'remove_from_cart')
                    && note.item
                    && (note.item.variant_id  === payload.variant_id && note.item.id === payload.id)
                    && note.item.uid === payload.uid
                );

        if(index !== -1) {
            let areThereFreeProduct = !!(Object.keys(state.cart.items.filter(i => i.grouped_product)).length)
            state.cart.items.push(payload)

            if(payload.grouped_product && !areThereFreeProduct) {
                const groupedCartItem = mapCartItem({product: payload.grouped_product})
                groupedCartItem.quantity = 1
                groupedCartItem.price = 0
                const [index, item] = getCurrentItem(state.cart.items, groupedCartItem)
                if(!state.cart.items[index] && state.cart.items) {
                    state.cart.items.push(groupedCartItem)
                }
            }

            state.app.removedItems.splice(index, 1)
        }

        if (removedNoteIndex !== -1) {
            state.app.notifications.items.splice(removedNoteIndex, 1);
        }


        for(let j = 0; j < state.cart.items.length; j++) {

            // if(state.cart.items[j].grouped_product)
            // {
            //     state.cart.items.push(state.cart.items[j]);
            //     state.cart.items.splice(j, 1);
            // }

            if(state.cart.items[j].is_group_of && ( !state.cart.items[j].price || state.cart.items[j].price == '0.00'))
            {
                state.cart.items.push(state.cart.items[j]);
                state.cart.items.splice(j, 1);
            }
        }

        if(!state.app.auth)
        {
            state.cart.cart_type = state.cart.cart_type == '1' ? '0' : state.cart.cart_type;
        }

    },
    EMPTY_CART (state) {
        state.app.removedItems = state.app.removedItems.concat(state.cart.items);
        state.cart.items = []

        if(!state.app.auth)
        {
            state.cart.cart_type = state.cart.cart_type == '1' ? '0' : state.cart.cart_type;
        }
    },
    UNDO_REMOVED_ITEMS (state) {
        state.app.notifications.items = state.app.notifications.items.filter(note => (note.type !== 'remove_from_cart' && note.type !== 'all_removed') );
        state.cart.items = state.cart.items.concat(state.app.removedItems);
        state.app.removedItems = [];

        for(let j = 0; j < state.cart.items.length; j++) {

            // if(state.cart.items[j].grouped_product)
            // {
            //     state.cart.items.push(state.cart.items[j]);
            //     state.cart.items.splice(j, 1);
            // }

            if(state.cart.items[j].is_group_of  && ( !state.cart.items[j].price || state.cart.items[j].price == '0.00'))
            {
                state.cart.items.push(state.cart.items[j]);
                state.cart.items.splice(j, 1);
            }
        }

        if(!state.app.auth)
        {
            state.cart.cart_type = state.cart.cart_type == '1' ? '0' : state.cart.cart_type;
        }


    },
    //TODO: CHECKOUT #
    UPDATE_BILLING_INFO (state, payload) {

        if(typeof payload === 'object') {
            const keys = Object.keys(payload)

            for(let i = 0; i < keys.length; i++) {
                state[keys[i]] = payload[keys[i]]
            }
        }
    },
    //TODO: SHIPPING
    SELECT_SHIPPING_RATE (state, payload) {
        state.shipping_methods.selected = payload.selected
    },

    UPDATE_SHIPPING_RATES (state, payload) {

        let isLtl = false;
        // for(let i = 0; i < (payload || []).length; i++ ) {
        //     if(payload[i]?.label?.includes('LTL')) {
        //         isLtl = true;
        //         break;
        //     }
        // }

        const rates = (payload || []).sort((a,b)=>a.cost - b.cost).filter(i => !isLtl || i?.label?.includes('LTL'));
        state.shipping_methods.rates = isLtl && rates[0] ? [{...rates[0], ...{label: 'Shipping - LTL:'}}] : rates;
        state.shipping_methods.selected = payload && payload[0] ? (payload[0].id || (payload[0].type === 'ground_freight' ? 'ground_freight' : null)): null
    },
    SET_SHIPPING_CUSTOM_PRICE (state, payload) {
        const currentRateIndex = state.shipping_methods.rates.findIndex(i => i.type === state.shipping_methods.selected);
        if(currentRateIndex !== -1) {
            state.shipping_methods.rates[currentRateIndex].cost = payload.custom_shipping_details;
            if(payload.is_reset_shipping){
                state.shipping_methods.custom_price = null;
            }
            else
            {
                if(state.shipping_methods.defaultCost != payload.custom_shipping_details)
                    state.shipping_methods.custom_price = payload.custom_shipping_details;
            }
            var isClassExists = document.getElementsByClassName('custom_shipping_qty_update');
            if (isClassExists.length > 0) {
                setTimeout( () => {
                    isClassExists[0].value = payload.custom_shipping_details;
                }, 50)
            }
        }
    },
    CLEAR_SHIPPING_RATES (state) {
        state.shipping_methods.rates = []
        state.shipping_methods.selected = null
        state.shipping_methods.custom_price = null
        state.shipping_methods.defaultCost = null
    },
    CLEAR_SHARED_CART_HASH (state) {
        state.cart.sharedCartHash = null
    }
}
